export default "__VITE_PUBLIC_ASSET__b58bc52c__"